import { App } from '@web/App'
import { initializeAppearance } from '@web/theme/appearance'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@web/styles.css'

// Brand precedence: URL ?brand= > localStorage > build-time VITE_BRAND > "bridge".
const params = new URLSearchParams(window.location.search)
const brand =
  params.get('brand') ||
  localStorage.getItem('bridge.brand') ||
  (import.meta.env.VITE_BRAND as string | undefined) ||
  'bridge'
document.documentElement.dataset.brand = brand
if (params.get('brand')) localStorage.setItem('bridge.brand', brand)
// `?theme=dark|light|system` persists an explicit choice. Missing or obsolete
// preferences follow the operating system.
initializeAppearance(params.get('theme'))

// Icon animations run on click: mark the clicked button (or an opted-in
// .icon-anim pill) with .icon-play for the animation's length. Removing and
// re-adding the class restarts the animation on rapid clicks.
document.addEventListener('click', (e) => {
  const el = (e.target as Element | null)?.closest(
    'button, [role="button"], .icon-anim',
  )
  if (!el || (el as HTMLButtonElement).disabled) return
  el.classList.remove('icon-play')
  void (el as HTMLElement).offsetWidth
  el.classList.add('icon-play')
  window.setTimeout(() => el.classList.remove('icon-play'), 800)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
